import { SVGProps, Ref, forwardRef } from 'react';

export const ImageStackFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M8 .5c3.442 0 5.152.242 5.748 1.534a9 9 0 0 0-1.574-.377C11.018 1.479 9.62 1.43 8 1.43s-3.018.049-4.173.227c-.55.084-1.08.203-1.575.377C2.848.742 4.558.5 8 .5"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.641 9.165C-.028 3.622 1.561 2.83 8 2.83s8.028.792 7.359 6.335c-.125 1.034-.258 1.903-.43 2.632l-3.513-2.543-2.28 1.572-3.412-2.348-4.651 3.324c-.173-.73-.307-1.6-.432-2.637M10.5 6c-.875 0-1.167.583-1.167 1.167 0 .583.292 1.166 1.167 1.166s1.167-.583 1.167-1.166C11.667 6.583 11.375 6 10.5 6"
                    fill="currentColor"
                />
                <path
                    d="m11.396 10.968 3.076 2.227C13.582 15.139 11.898 15.5 8 15.5c-3.897 0-5.582-.361-6.47-2.303l4.21-3.009 3.397 2.337z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ImageStackFilledSize16Glyph.displayName = 'ImageStackFilledSize16Glyph';
